export enum LoadingVariants {
  Primary,
  Secondary,
}

export interface LoadingProps {
  size: number;
  variant?: LoadingVariants;
  className?: string;
}
